import { Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { ISwapQualityIssueCounts } from '@nkr/models/index';
import { SwapQualityIssueReportedBy } from '@nkr/enums/index';
import { NavItemWrapper } from '../styles';

interface IProps {
    counts: ISwapQualityIssueCounts,
    reportBy: SwapQualityIssueReportedBy,
    activeKey: string,
    isAdmin: boolean,
    isNkrLogin: boolean,
    centerId: number,
}

const SwapQualityIssuesNav = (props: IProps) => {
    const hrefPrefix = !props.isAdmin ? `/center/${props.centerId}/action-center/swap-quality-issues/list` : `/admin/swap-quality-issues/list`;

    return (
        <div style={{ paddingTop: 5 }}>
            <Nav bsStyle='tabs' activeKey={props.activeKey}>
                <LinkContainer to={{ pathname: hrefPrefix + '/pending-response', search: 'reportedBy=' + props.reportBy }}>
                    <NavItem eventKey={'PENDING-RESPONSE'}>
                        Pending Response <span className='type-count'>({props.counts.pendingResponse})</span>
                    </NavItem>
                </LinkContainer>

                <LinkContainer to={{ pathname: hrefPrefix + '/issue-reported-incomplete', search: 'reportedBy=' + props.reportBy }}>
                    <NavItemWrapper eventKey={'ISSUE-REPORTED-INCOMPLETE'}>
                        Issue Reported - Incomplete <span className='type-count'>({props.counts.issueReportedIncomplete})</span>
                    </NavItemWrapper>
                </LinkContainer>

                <LinkContainer to={{ pathname: hrefPrefix + '/issue-reported-complete', search: 'reportedBy=' + props.reportBy }}>
                    <NavItemWrapper eventKey={'ISSUE-REPORTED-COMPLETE'}>
                        Issue Reported - Complete <span className='type-count'>({props.counts.issueReportedCompleted})</span>
                    </NavItemWrapper>
                </LinkContainer>

                <LinkContainer to={{ pathname: hrefPrefix + '/no-issue-reported', search: 'reportedBy=' + props.reportBy }}>
                    <NavItemWrapper eventKey={'NO-ISSUE-REPORTED'}>
                        No Issue Reported <span className='type-count'>({props.counts.noIssueReported})</span>
                    </NavItemWrapper>
                </LinkContainer>

                <LinkContainer to={{ pathname: hrefPrefix + '/all', search: 'reportedBy=' + props.reportBy }}>
                    <NavItemWrapper eventKey={'ALL'}>
                        All <span className='type-count'>({props.counts.total})</span>
                    </NavItemWrapper>
                </LinkContainer>
            </Nav>
        </div>
    );
}

export default SwapQualityIssuesNav;